/**
 * PHI (protected health information) marking for browser-automation redaction.
 *
 * Spread `phiProps()` onto any element that renders PHI — patient name, MRN,
 * date of birth, phone, avatar/initials, etc. The `data-phi` attribute is inert
 * in production (it changes nothing a real user sees); it exists so an automated
 * QA / browser agent can blank these nodes before a snapshot or screenshot
 * leaves the app for an external system (e.g. an LLM context). See the
 * agent-browser skill's "Handling PHI" section for the masking pass that
 * consumes it.
 */
export const PHI_DATA_ATTRIBUTE = 'data-phi';

/** Spread onto an element rendering PHI: `<span {...phiProps()}>{mrn}</span>`. */
export const phiProps = (): Record<typeof PHI_DATA_ATTRIBUTE, ''> => ({
  [PHI_DATA_ATTRIBUTE]: '',
});
